import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { Section } from '@whitbread-eos/atoms';
import { renderSanitizedHtml, useSemanticTypography, useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HotelDescriptionInformation = () => {
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useStaticHotelInform = useStaticHotelInformation(),
    hotelDescription = _useStaticHotelInform.hotelDescription,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error;
  var getTypographyProps = useSemanticTypography();
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  if (!hotelDescription) {
    return null;
  }
  return _jsx(Section, {
    dataTestId: "hdp_description",
    children: _jsxs(Box, _objectSpread(_objectSpread({
      maxW: "full",
      "data-testid": "hotel-details-description"
    }, containerStyles), {}, {
      children: [_jsx(Text, _objectSpread(_objectSpread({
        as: "h3"
      }, getTypographyProps(headingDescriptionLegacyTypography, headingDescriptionSemanticTypography)), {}, {
        children: t('hoteldetails.description')
      })), _jsx(Box, _objectSpread(_objectSpread({
        mt: {
          base: '2',
          sm: '1'
        },
        className: "formatLinks"
      }, getTypographyProps({}, formatLinksDescriptionSemanticTypography)), {}, {
        children: renderSanitizedHtml(hotelDescription)
      }))]
    }))
  });
};
var formatLinksDescriptionSemanticTypography = {
  textStyle: 'body-m-regular'
};
var headingDescriptionLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: {
    base: 'xl',
    sm: '2xl'
  },
  lineHeight: {
    base: '3',
    sm: '4'
  }
};
var headingDescriptionSemanticTypography = {
  textStyle: {
    base: 'heading-s',
    md: 'heading-m'
  }
};
var containerStyles = {
  mt: {
    base: 'lg',
    sm: '3xl'
  },
  mb: {
    base: 'lg',
    sm: '2xl'
  }
};